import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button } from '@mui/material';
import { useFormikContext } from 'formik';
import { useWizard } from 'react-use-wizard';
import { FormattedMessage } from 'react-intl';
import { WizardFinalizeBtn } from './WizardFinalizeBtn';

export function WizardActionsFormik() {
  const { previousStep } = useWizard();
  const formik = useFormikContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', mt: 5, gap: 2 }}>
      <Button color="warning" variant="outlined" onClick={previousStep}>
        <FormattedMessage id="common.wizard.back" defaultMessage="Atrás" />
      </Button>
      <Button
        onClick={() => {
          formik.handleSubmit();
        }}
        variant="outlined"
        startIcon={<ArrowForwardIcon />}
      >
        <FormattedMessage id="common.wizard.next" defaultMessage="Siguiente" />
      </Button>
      <WizardFinalizeBtn />
    </Box>
  );
}
